import type SessionService from '@efdigital/ll-addon-auth/services/session';
import {
  NEEDS_ATTENTION_BY_USER_KEYS,
  UPCOMING_KEYS,
} from '@efdigital/ll-addon-coaching/utils/coaching-sessions/session-status';
import {
  type CoachingSession,
  type CoachProfile,
} from '@efdigital/ll-addon-data';
import { queryCoachProfilesByUserIds } from '@efdigital/ll-xceed-v2/data/builders/coaching/coach-profiles';
import { queryCoachingSessionsByCoachingPlan } from '@efdigital/ll-xceed-v2/data/builders/coaching/coaching-sessions';
import type CoacheeService from '@efdigital/ll-xceed-v2/services/coachee';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

import type { CoachingCoacheeCohortModel } from '../../cohort';

export type CoachingCoacheeCohortSessionsIndexModel =
  CoachingCoacheeCohortModel & {
    upcoming: CoachingSession[];
    needsAttention: CoachingSession[];
    coaches: CoachProfile[];
  };

export default class CoachingCoacheeCohortSessionsIndexRoute extends Route<CoachingCoacheeCohortSessionsIndexModel> {
  @service declare coachee: CoacheeService;
  @service declare store: Store;
  @service declare session: SessionService;

  async model(): Promise<CoachingCoacheeCohortSessionsIndexModel> {
    const cohortModel = this.modelFor(
      'coaching.coachee.cohort'
    ) as CoachingCoacheeCohortModel;

    const queryUpcoming = queryCoachingSessionsByCoachingPlan(
      cohortModel.coachingPlan!.id!,
      UPCOMING_KEYS
    );
    const upcomingSessions = await this.store.request(queryUpcoming);
    console.log(upcomingSessions.content.data);
    const upcoming = upcomingSessions.content.data;

    const queryNeedsAttention = queryCoachingSessionsByCoachingPlan(
      cohortModel.coachingPlan!.id!,
      NEEDS_ATTENTION_BY_USER_KEYS
    );
    const needsAttention = (await this.store.request(queryNeedsAttention))
      .content.data;

    const coachUserIds = Array.from(
      new Set([
        ...upcoming.map((session) => session.coachUserId),
        ...needsAttention.map((session) => session.coachUserId),
      ])
    );
    const queryCoaches = queryCoachProfilesByUserIds(coachUserIds);
    const coaches = await this.store.request(queryCoaches);

    return {
      ...cohortModel,
      upcoming,
      needsAttention,
      coaches: coaches.content.data,
    };
  }
}
